import { styled } from "@mui/material";

export const ButtonContainer = styled("div")(() => ({
    display: "flex",
    justifyContent: "end",
    gap: "16px",
    marginTop: "16px",
}))

export const CancelButton = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    color: "#495057",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: "DM Sans, sans-serif",
}))